import { render, staticRenderFns } from "./DuplicateAwardSource.vue?vue&type=template&id=05961c3a&scoped=true&"
import script from "./DuplicateAwardSource.vue?vue&type=script&setup=true&lang=js&"
export * from "./DuplicateAwardSource.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DuplicateAwardSource.vue?vue&type=style&index=0&id=05961c3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05961c3a",
  null
  
)

export default component.exports